<template>
  <line-chart
    class="fill-height"
    type="bar"
    :raw-data="periods"
    :chart-value-keys="chartValueKeys"
    x-value="title"
    y-value-prefix="teams[0].team_stats."
    :stacked="true"
    :xaxis="{
      labels: {
        rotate: -45
      },
      tickPlacement: 'between'
    }"
    :colors="[ '#008FFB', '#F4A641', '#F9E03B', '#86CC8E', '#DD644C']"
    :fill="{ opacity: [1, 1, 1, 1, 1]}"
    :loading="loading"
  >
    <template v-slot:header>
      <v-card-title class="pa-6 d-flex justify-space-between">
        <div class="subtitle-2 grey--text text--grey-100">
          {{ $t('card_title.speed_zones') }}
        </div>
        <v-btn
          v-if="removable"
          icon
          style="pointer-events: auto"
          @click="$emit('remove')"
        >
          <v-icon small>
            fal fa-times
          </v-icon>
        </v-btn>
      </v-card-title>
    </template>
  </line-chart>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue'

export default {
  name: 'SpeedZonePeriodChart',
  components: { LineChart },
  props: {
    periods: {
      type: Array,
      required: true
    },
    chart: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    removable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    chartValueKeys() {
      return [
        { key: 'CACTCSVB1TD', type: 'bar', label: this.$t('gps_variables.speed_0_7') },
        { key: 'CACTCSVB2TD', type: 'bar', label: this.$t('gps_variables.speed_7_14.4') },
        { key: 'CACTCSVB3TD', type: 'bar', label: this.$t('gps_variables.speed_14.4_19.8') },
        { key: 'CALETLDLHSR', type: 'bar', label: this.$t('gps_variables.hsr') },
        { key: 'CALETLDLSP', type: 'bar', label: this.$t('gps_variables.sprint') }
      ]
    }
  }
}
</script>
